import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const condition = {
    path: '/contracts',
    component: Layout,
    name: 'contracts',
    redirect: '/contracts/index',
    children: [
      {
        path: '/contracts/index',
        component: () => import('@/views/contracts/index'),
        name: 'contracts.index',
        meta: { title: i18n.t(`message.contracts`)}
      },
    ]
  }

export default condition
